import { District } from '../interfaces/prop.interface';

export const districtsJson: District[] = [
    {
        "id": "5029710",
        "name": "Actur-Arrabal",
        "fk_idCity": "1150297",
        "lat": 41.6716846,
        "lng": -0.8888689999999999
    },
    {
        "id": "4625013",
        "name": "Algir\u00f3s",
        "fk_idCity": "1146250",
        "lat": 39.4781707,
        "lng": -0.3442449
    },
    {
        "id": "807302",
        "name": "Almeda",
        "fk_idCity": "1108073",
        "lat": 41.3572807,
        "lng": 2.0887505
    },
    {
        "id": "2807902",
        "name": "Arganzuela",
        "fk_idCity": "1128079",
        "lat": 40.39806845,
        "lng": -3.69373395265674
    },
    {
        "id": "2408909",
        "name": "Armunia & Oteruelo de la Valdoncina",
        "fk_idCity": "1124089",
        "lat": 42.5747523,
        "lng": -5.589158299999999
    },
    {
        "id": "3412002",
        "name": "Allende del R\u00edo & Zona Industrial",
        "fk_idCity": "1134120",
        "lat": 42.0109824,
        "lng": -4.5456042
    },
    {
        "id": "3803801",
        "name": "Anaga",
        "fk_idCity": "1138038",
        "lat": 28.4941681,
        "lng": -16.2757514
    },
    {
        "id": "4801306",
        "name": "Arteagabeitia",
        "fk_idCity": "1148013",
        "lat": 43.2919248,
        "lng": -2.9936234
    },
    {
        "id": "4801304",
        "name": "Bagatza Beurko",
        "fk_idCity": "1148013",
        "lat": 43.3006255,
        "lng": -2.9964185
    },
    {
        "id": "2807921",
        "name": "Barajas",
        "fk_idCity": "1128079",
        "lat": 40.4653704,
        "lng": -3.5951518
    },
    {
        "id": "3907505",
        "name": "Barrio Pesquero",
        "fk_idCity": "1139075",
        "lat": 43.4509909,
        "lng": -3.8208031
    },
    {
        "id": "4625016",
        "name": "Benicalap",
        "fk_idCity": "1146250",
        "lat": 39.4935471,
        "lng": -0.3913172
    },
    {
        "id": "5029711",
        "name": "Barrios Zona Norte",
        "fk_idCity": "1150297",
        "lat": 41.6488226,
        "lng": -0.8890853
    },
    {
        "id": "4625014",
        "name": "Benimaclet",
        "fk_idCity": "1146250",
        "lat": 39.4871955,
        "lng": -0.3548312
    },
    {
        "id": "818403",
        "name": "Can Alzamora & Les Torres",
        "fk_idCity": "1108184",
        "lat": 41.4797626,
        "lng": 2.0358317
    },
    {
        "id": "2906710",
        "name": "Carretera de C\u00e1diz",
        "fk_idCity": "1129067",
        "lat": 36.701525,
        "lng": -4.4436062
    },
    {
        "id": "820005",
        "name": "Camps Blancs",
        "fk_idCity": "1108200",
        "lat": 41.3362485,
        "lng": 2.0346038
    },
    {
        "id": "4802008",
        "name": "Basurto & Zorroza",
        "fk_idCity": "1148020",
        "lat": 43.2592141,
        "lng": -2.9517536
    },
    {
        "id": "3603807",
        "name": "Campa\u00f1\u00f3 & Cerponz\u00f3ns",
        "fk_idCity": "1136038",
        "lat": 42.4643963,
        "lng": -8.663611999999999
    },
    {
        "id": "2807911",
        "name": "Carabanchel",
        "fk_idCity": "1128079",
        "lat": 40.3778181,
        "lng": -3.7512317
    },
    {
        "id": "2805801",
        "name": "Avanzada-La Cueva",
        "fk_idCity": "1128058",
        "lat": 40.2774625,
        "lng": -3.7943157
    },
    {
        "id": "4109101",
        "name": "Casco Antiguo",
        "fk_idCity": "1141091",
        "lat": 37.3926944,
        "lng": -5.9953959
    },
    {
        "id": "5029712",
        "name": "Barrios Zona Oeste",
        "fk_idCity": "1150297",
        "lat": 41.6488226,
        "lng": -0.8890853
    },
    {
        "id": "820006",
        "name": "Casablanca",
        "fk_idCity": "1108200",
        "lat": 41.3324505,
        "lng": 2.0398351
    },
    {
        "id": "4516503",
        "name": "Casco Antiguo",
        "fk_idCity": "1145165",
        "lat": 39.962884,
        "lng": -4.830453599999999
    },
    {
        "id": "4625004",
        "name": "Campanar",
        "fk_idCity": "1146250",
        "lat": 39.4818921,
        "lng": -0.3948498
    },
    {
        "id": "704001",
        "name": "Centro",
        "fk_idCity": "1107040",
        "lat": 39.5726328,
        "lng": 2.651191400000001
    },
    {
        "id": "5029702",
        "name": "Centro",
        "fk_idCity": "1150297",
        "lat": 41.6451466,
        "lng": -0.8889678
    },
    {
        "id": "2906901",
        "name": "Casco Urbano de Marbella",
        "fk_idCity": "1129069",
        "lat": 36.510071,
        "lng": -4.8824474
    },
    {
        "id": "2906701",
        "name": "Centro",
        "fk_idCity": "1129067",
        "lat": 36.7184187,
        "lng": -4.4197803
    },
    {
        "id": "905901",
        "name": "Centro",
        "fk_idCity": "1109059",
        "lat": 42.3504659,
        "lng": -3.689354499999999
    },
    {
        "id": "2906703",
        "name": "Carreter\u00eda y Alamos",
        "fk_idCity": "1129067",
        "lat": 36.7243068,
        "lng": -4.4205339
    },
    {
        "id": "812101",
        "name": "Centre",
        "fk_idCity": "1108121",
        "lat": 41.5381124,
        "lng": 2.4447406
    },
    {
        "id": "2811502",
        "name": "Casco Urbano",
        "fk_idCity": "1128115",
        "lat": 40.4440627,
        "lng": -3.8058517
    },
    {
        "id": "2807901",
        "name": "Centro",
        "fk_idCity": "1128079",
        "lat": 40.4115165,
        "lng": -3.7076445
    },
    {
        "id": "2807915",
        "name": "Ciudad Lineal",
        "fk_idCity": "1128079",
        "lat": 40.4456678,
        "lng": -3.6543844
    },
    {
        "id": "4109104",
        "name": "Cerro-Amate",
        "fk_idCity": "1141091",
        "lat": 37.3783675,
        "lng": -5.9435709
    },
    {
        "id": "820001",
        "name": "Ciudad Cooperativa & Mol\u00ed Nou",
        "fk_idCity": "1108200",
        "lat": 41.35606120000001,
        "lng": 2.030561
    },
    {
        "id": "2810601",
        "name": "District Parla",
        "fk_idCity": "1128106",
        "lat": 40.2373062,
        "lng": -3.7739869
    },
    {
        "id": "4516806",
        "name": "Casco Hist\u00f3rico",
        "fk_idCity": "1145168",
        "lat": 39.8580671,
        "lng": -4.0268864
    },
    {
        "id": "801904",
        "name": "Corts",
        "fk_idCity": "1108019",
        "lat": 41.38447,
        "lng": 2.1107283
    },
    {
        "id": "3907501",
        "name": "Centro",
        "fk_idCity": "1139075",
        "lat": 43.4636346,
        "lng": -3.8226402
    },
    {
        "id": "3300401",
        "name": "District Avil\u00e9s",
        "fk_idCity": "1133004",
        "lat": 43.5579523,
        "lng": -5.9246653
    },
    {
        "id": "4802001",
        "name": "Deusto",
        "fk_idCity": "1148020",
        "lat": 43.2769911,
        "lng": -2.9525632
    },
    {
        "id": "3120101",
        "name": "Casco Antiguo",
        "fk_idCity": "1131201",
        "lat": 42.8178265,
        "lng": -1.6464701
    },
    {
        "id": "2800601",
        "name": "District Alcobendas",
        "fk_idCity": "1128006",
        "lat": 40.5371361,
        "lng": -3.6370715
    },
    {
        "id": "2305005",
        "name": "Distrito Norte",
        "fk_idCity": "1123050",
        "lat": 38.0986026,
        "lng": -3.6363807
    },
    {
        "id": "2305003",
        "name": "Distrito Oeste",
        "fk_idCity": "1123050",
        "lat": 37.7795941,
        "lng": -3.784905699999999
    },
    {
        "id": "2305009",
        "name": "Distrito Los Puentes",
        "fk_idCity": "1123050",
        "lat": 37.7795941,
        "lng": -3.784905699999999
    },
    {
        "id": "2305006",
        "name": "Distrito Sur",
        "fk_idCity": "1123050",
        "lat": 37.457248,
        "lng": -3.918319799999999
    },
    {
        "id": "2305008",
        "name": "Distrito La Alcantarilla",
        "fk_idCity": "1123050",
        "lat": 37.7630419,
        "lng": -3.7884452
    },
    {
        "id": "801506",
        "name": "Distrito VI",
        "fk_idCity": "1108015",
        "lat": 41.446964,
        "lng": 2.2449607
    },
    {
        "id": "4100402",
        "name": "Distrito Sur",
        "fk_idCity": "1141004",
        "lat": 37.3224323,
        "lng": -5.8620374
    },
    {
        "id": "1503007",
        "name": "Distrito 7",
        "fk_idCity": "1115030",
        "lat": 43.3623436,
        "lng": -8.4115401
    },
    {
        "id": "3302407",
        "name": "El Llano",
        "fk_idCity": "1133024",
        "lat": 43.5297956,
        "lng": -5.665515699999999
    },
    {
        "id": "2104101",
        "name": "Centro",
        "fk_idCity": "1121041",
        "lat": 37.2619585,
        "lng": -6.9427327
    },
    {
        "id": "105901",
        "name": "Centro",
        "fk_idCity": "1101059",
        "lat": 42.8531869,
        "lng": -2.6732421
    },
    {
        "id": "1402101",
        "name": "Centro",
        "fk_idCity": "1114021",
        "lat": 37.8871927,
        "lng": -4.7743365
    },
    {
        "id": "3412001",
        "name": "Centro & Casco Hist\u00f3rico",
        "fk_idCity": "1134120",
        "lat": 19.4302678,
        "lng": -99.1373136
    },
    {
        "id": "3412005",
        "name": "Centro Sur, Parque Isabel II & Este",
        "fk_idCity": "1134120",
        "lat": 40.4421065,
        "lng": -3.7050986
    },
    {
        "id": "2816101",
        "name": "Centro ciudad",
        "fk_idCity": "1128161",
        "lat": 40.1912635,
        "lng": -3.6740351
    },
    {
        "id": "4516804",
        "name": "Centro Noroeste",
        "fk_idCity": "1145168",
        "lat": 39.8628316,
        "lng": -4.027323099999999
    },
    {
        "id": "3501602",
        "name": "Centro",
        "fk_idCity": "1135016",
        "lat": 28.1008837,
        "lng": -15.4653897
    },
    {
        "id": "807301",
        "name": "Centro & Riera",
        "fk_idCity": "1108073",
        "lat": 19.4302678,
        "lng": -99.1373136
    },
    {
        "id": "4516802",
        "name": "Centro Sudeste",
        "fk_idCity": "1145168",
        "lat": 39.8628316,
        "lng": -4.027323099999999
    },
    {
        "id": "2807907",
        "name": "Chamber\u00ed",
        "fk_idCity": "1128079",
        "lat": 40.4344286,
        "lng": -3.7131782
    },
    {
        "id": "2807905",
        "name": "Chamart\u00edn",
        "fk_idCity": "1128079",
        "lat": 40.4615174,
        "lng": -3.6865844
    },
    {
        "id": "2805803",
        "name": "Cerro-El Molino",
        "fk_idCity": "1128058",
        "lat": 40.2864475,
        "lng": -3.8058734
    },
    {
        "id": "2800503",
        "name": "Chorrillo/Garena",
        "fk_idCity": "1128005",
        "lat": 40.4843898,
        "lng": -3.3688023
    },
    {
        "id": "812105",
        "name": "Cerdanyola",
        "fk_idCity": "1108121",
        "lat": 41.54224749999999,
        "lng": 2.4218359
    },
    {
        "id": "3003002",
        "name": "Centro-Este",
        "fk_idCity": "1130030",
        "lat": 37.9922399,
        "lng": -1.1306544
    },
    {
        "id": "3603802",
        "name": "Eixanxe",
        "fk_idCity": "1136038",
        "lat": 42.4298846,
        "lng": -8.6446202
    },
    {
        "id": "2805802",
        "name": "Centro-El Arroyo-La Fuente",
        "fk_idCity": "1128058",
        "lat": 40.2756279,
        "lng": -3.7994405
    },
    {
        "id": "4516801",
        "name": "Centro Noreste",
        "fk_idCity": "1145168",
        "lat": 39.8628316,
        "lng": -4.027323099999999
    },
    {
        "id": "4625002",
        "name": "Eixample",
        "fk_idCity": "1146250",
        "lat": 39.4649902,
        "lng": -0.3735931
    },
    {
        "id": "2800501",
        "name": "Centro",
        "fk_idCity": "1128005",
        "lat": 40.4843898,
        "lng": -3.3688023
    },
    {
        "id": "801507",
        "name": "Distrito VII",
        "fk_idCity": "1108015",
        "lat": 41.446964,
        "lng": 2.2449607
    },
    {
        "id": "3003001",
        "name": "El Carmen",
        "fk_idCity": "1130030",
        "lat": 37.9796097,
        "lng": -1.130208
    },
    {
        "id": "3502606",
        "name": "Distritos Median\u00edas",
        "fk_idCity": "1135026",
        "lat": 27.9799946,
        "lng": -15.4276754
    },
    {
        "id": "3003003",
        "name": "Centro-Oeste",
        "fk_idCity": "1130030",
        "lat": 37.9922399,
        "lng": -1.1306544
    },
    {
        "id": "3412007",
        "name": "El C\u00e1rmen & F\u00e1brica de Armas",
        "fk_idCity": "1134120",
        "lat": -0.2714362,
        "lng": -79.4647633
    },
    {
        "id": "2906706",
        "name": "Ciudad Jard\u00edn",
        "fk_idCity": "1129067",
        "lat": 36.7490007,
        "lng": -4.4198959
    },
    {
        "id": "309901",
        "name": "Ciudad - Sudeste",
        "fk_idCity": "1103099",
        "lat": 38.08555279999999,
        "lng": -0.9480050999999999
    },
    {
        "id": "4801302",
        "name": "Desierto Lasesarre",
        "fk_idCity": "1148013",
        "lat": 43.3020138,
        "lng": -2.9896526
    },
    {
        "id": "2813401",
        "name": "District San Sebasti\u00e1n de los Reyes",
        "fk_idCity": "1128134",
        "lat": 40.5589672,
        "lng": -3.6261976
    },
    {
        "id": "3800601",
        "name": "District Arona",
        "fk_idCity": "1138006",
        "lat": 28.0999496,
        "lng": -16.679977
    },
    {
        "id": "3907502",
        "name": "Cuatro Caminos-San Fernando",
        "fk_idCity": "1139075",
        "lat": 43.4586526,
        "lng": -3.8262151
    },
    {
        "id": "4801309",
        "name": "Cruces",
        "fk_idCity": "1148013",
        "lat": 43.2807845,
        "lng": -2.9868366
    },
    {
        "id": "5029703",
        "name": "Delicias",
        "fk_idCity": "1150297",
        "lat": 41.6492335,
        "lng": -0.9091511999999998
    },
    {
        "id": "309906",
        "name": "Desamparados & Hurchillo",
        "fk_idCity": "1103099",
        "lat": 9.8969706,
        "lng": -84.0616709
    },
    {
        "id": "309902",
        "name": "Ciudad - Sudoeste",
        "fk_idCity": "1103099",
        "lat": 38.08555279999999,
        "lng": -0.9480050999999999
    },
    {
        "id": "905904",
        "name": "El Castillo",
        "fk_idCity": "1109059",
        "lat": 42.3426347,
        "lng": -3.708273
    },
    {
        "id": "3501604",
        "name": "Ciudad Alta",
        "fk_idCity": "1135016",
        "lat": 28.6664392,
        "lng": -17.7968884
    },
    {
        "id": "818404",
        "name": "Ciudad",
        "fk_idCity": "1108184",
        "lat": 41.4971174,
        "lng": 2.0349243
    },
    {
        "id": "2104107",
        "name": "El Torrej\u00f3n",
        "fk_idCity": "1121041",
        "lat": 37.2739075,
        "lng": -6.9343949
    },
    {
        "id": "2807908",
        "name": "Fuencarral-El Pardo",
        "fk_idCity": "1128079",
        "lat": 40.49539598134449,
        "lng": -3.693429413123469
    },
    {
        "id": "801902",
        "name": "Ensanche",
        "fk_idCity": "1108019",
        "lat": 41.3922586,
        "lng": 2.1650273
    },
    {
        "id": "4625003",
        "name": "Extramurs",
        "fk_idCity": "1146250",
        "lat": 39.4728624,
        "lng": -0.3866074
    },
    {
        "id": "3003004",
        "name": "Este",
        "fk_idCity": "1130030",
        "lat": 37.9922399,
        "lng": -1.1306544
    },
    {
        "id": "2104103",
        "name": "El Matadero",
        "fk_idCity": "1121041",
        "lat": 37.2619585,
        "lng": -6.9427327
    },
    {
        "id": "501902",
        "name": "Extramuros y Encarnaci\u00f3n",
        "fk_idCity": "1105019",
        "lat": 40.6627331,
        "lng": -4.6979117
    },
    {
        "id": "3802304",
        "name": "Guamasa-Los Bald\u00edos-Los Rodeos-El Ortigal",
        "fk_idCity": "1138023",
        "lat": 28.484511,
        "lng": -16.3434204
    },
    {
        "id": "2800504",
        "name": "Ensanche/Espartales",
        "fk_idCity": "1128005",
        "lat": 40.5068164,
        "lng": -3.3702819
    },
    {
        "id": "3412006",
        "name": "El Cristo & Tejera",
        "fk_idCity": "1134120",
        "lat": 19.0404807,
        "lng": -98.1700496
    },
    {
        "id": "812102",
        "name": "El Palau",
        "fk_idCity": "1108121",
        "lat": 41.545587,
        "lng": 2.453057
    },
    {
        "id": "3120102",
        "name": "I y II Ensanche",
        "fk_idCity": "1131201",
        "lat": 42.8131324,
        "lng": -1.6391962
    },
    {
        "id": "4625006",
        "name": "El Pla del Real",
        "fk_idCity": "1146250",
        "lat": 39.47295250000001,
        "lng": -0.3583606
    },
    {
        "id": "3302404",
        "name": "El Natahoyo",
        "fk_idCity": "1133024",
        "lat": 43.5408662,
        "lng": -5.683927499999999
    },
    {
        "id": "2104102",
        "name": "El Molino de la Vega",
        "fk_idCity": "1121041",
        "lat": 37.2644171,
        "lng": -6.9584334
    },
    {
        "id": "2807916",
        "name": "Hortaleza",
        "fk_idCity": "1128079",
        "lat": 40.4808253,
        "lng": -3.64402712780169
    },
    {
        "id": "801907",
        "name": "Horta & Guinard\u00f3",
        "fk_idCity": "1108019",
        "lat": 41.43326039999999,
        "lng": 2.1523799
    },
    {
        "id": "801906",
        "name": "Gracia",
        "fk_idCity": "1108019",
        "lat": 41.4111806,
        "lng": 2.157474000000001
    },
    {
        "id": "501906",
        "name": "La Cacharra-San Antonio-Estaci\u00f3n-Las Hervencias",
        "fk_idCity": "1105019",
        "lat": 40.6609699,
        "lng": -4.6903624
    },
    {
        "id": "3501603",
        "name": "Isleta, Puerto & Guanarteme",
        "fk_idCity": "1135016",
        "lat": 34.9078296,
        "lng": -106.6930811
    },
    {
        "id": "3003006",
        "name": "Infante Juan Manuel",
        "fk_idCity": "1130030",
        "lat": 37.9791447,
        "lng": -1.1178629
    },
    {
        "id": "2906711",
        "name": "Churriana",
        "fk_idCity": "1129067",
        "lat": 36.6652242,
        "lng": -4.4902774
    },
    {
        "id": "801901",
        "name": "Ciutat Vella",
        "fk_idCity": "1108019",
        "lat": 41.3813473,
        "lng": 2.1822708
    },
    {
        "id": "4625001",
        "name": "Ciutat Vella",
        "fk_idCity": "1146250",
        "lat": 39.4728932,
        "lng": -0.3771895
    },
    {
        "id": "309903",
        "name": "Ciudad - Noroeste",
        "fk_idCity": "1103099",
        "lat": 38.08555279999999,
        "lng": -0.9480050999999999
    },
    {
        "id": "4625009",
        "name": "Jes\u00fas",
        "fk_idCity": "1146250",
        "lat": 39.4469616,
        "lng": -0.3913172
    },
    {
        "id": "4801307",
        "name": "Kareaga Regato",
        "fk_idCity": "1148013",
        "lat": 43.2869809,
        "lng": -3.0077703
    },
    {
        "id": "501901",
        "name": "Intramuros y y Cuatro Postes",
        "fk_idCity": "1105019",
        "lat": 40.656685,
        "lng": -4.6812086
    },
    {
        "id": "2408906",
        "name": "La Chantr\u00eda & La Lastra",
        "fk_idCity": "1124089",
        "lat": 42.5888628,
        "lng": -5.5682371
    },
    {
        "id": "2905402",
        "name": "Los Boliches",
        "fk_idCity": "1129054",
        "lat": 36.5631965,
        "lng": -4.6042784
    },
    {
        "id": "2805806",
        "name": "Loranca-Nuevo Versalles-Parque Miraflores",
        "fk_idCity": "1128058",
        "lat": 40.2962295,
        "lng": -3.8306635
    },
    {
        "id": "2812701",
        "name": "Las Rozas",
        "fk_idCity": "1128127",
        "lat": 40.4935329,
        "lng": -3.8757916
    },
    {
        "id": "820504",
        "name": "La Floresta",
        "fk_idCity": "1108205",
        "lat": 41.4480577,
        "lng": 2.0756405
    },
    {
        "id": "2807406",
        "name": "La Fortuna",
        "fk_idCity": "1128074",
        "lat": 40.3581998,
        "lng": -3.7803388
    },
    {
        "id": "2408903",
        "name": "Las Ventas, Eras de Renueva & San Esteban",
        "fk_idCity": "1124089",
        "lat": 42.6075654,
        "lng": -5.5830907
    },
    {
        "id": "801505",
        "name": "Distrito V",
        "fk_idCity": "1108015",
        "lat": 41.3792496,
        "lng": 2.1691777
    },
    {
        "id": "309907",
        "name": "La Murada",
        "fk_idCity": "1103099",
        "lat": 38.1715352,
        "lng": -0.961758
    },
    {
        "id": "801508",
        "name": "Distrito VIII",
        "fk_idCity": "1108015",
        "lat": 41.446964,
        "lng": 2.2449607
    },
    {
        "id": "3302408",
        "name": "Laviada",
        "fk_idCity": "1133024",
        "lat": 43.5367258,
        "lng": -5.6707756
    },
    {
        "id": "4804403",
        "name": "Las Arenas",
        "fk_idCity": "1148044",
        "lat": 43.3259438,
        "lng": -3.0157768
    },
    {
        "id": "2906904",
        "name": "Las Chapas-R\u00edo Real",
        "fk_idCity": "1129069",
        "lat": 36.54648825986948,
        "lng": -4.842991618527559
    },
    {
        "id": "4109111",
        "name": "Los Remedios",
        "fk_idCity": "1141091",
        "lat": 37.3798771,
        "lng": -6.0059816
    },
    {
        "id": "501904",
        "name": "La Toledana-Valle Ambl\u00e9s",
        "fk_idCity": "1105019",
        "lat": 40.6458875,
        "lng": -4.6990395
    },
    {
        "id": "2408910",
        "name": "La Granja & El Ejido",
        "fk_idCity": "1124089",
        "lat": 40.9021226,
        "lng": -4.0072899
    },
    {
        "id": "2909405",
        "name": "La Vi\u00f1uela",
        "fk_idCity": "1129094",
        "lat": 36.8630324,
        "lng": -4.1414604
    },
    {
        "id": "2807910",
        "name": "Latina",
        "fk_idCity": "1128079",
        "lat": 40.40247979999999,
        "lng": -3.7464619
    },
    {
        "id": "704004",
        "name": "Levante",
        "fk_idCity": "1107040",
        "lat": 39.5572421,
        "lng": 2.7580701
    },
    {
        "id": "4625007",
        "name": "L'Olivereta",
        "fk_idCity": "1146250",
        "lat": 39.4722257,
        "lng": -0.396277
    },
    {
        "id": "3003005",
        "name": "La Flota-Vista Alegre",
        "fk_idCity": "1130030",
        "lat": 37.9962235,
        "lng": -1.1244559
    },
    {
        "id": "2104108",
        "name": "La Orden",
        "fk_idCity": "1121041",
        "lat": 37.28043,
        "lng": -6.936401999999999
    },
    {
        "id": "3907507",
        "name": "Los Castros",
        "fk_idCity": "1139075",
        "lat": 43.4695285,
        "lng": -3.8100898
    },
    {
        "id": "812104",
        "name": "La Llantia & Cirera",
        "fk_idCity": "1108121",
        "lat": 41.5493064,
        "lng": 2.4248665
    },
    {
        "id": "3603805",
        "name": "L\u00e9rez",
        "fk_idCity": "1136038",
        "lat": 42.4491631,
        "lng": -8.630732
    },
    {
        "id": "820506",
        "name": "Les Planes",
        "fk_idCity": "1108205",
        "lat": 41.4337976,
        "lng": 2.0906069
    },
    {
        "id": "4109102",
        "name": "Macarena",
        "fk_idCity": "1141091",
        "lat": 37.4025486,
        "lng": -5.9891918
    },
    {
        "id": "2906702",
        "name": "M\u00e1laga Este",
        "fk_idCity": "1129067",
        "lat": 36.7566511,
        "lng": -4.346237299999999
    },
    {
        "id": "820002",
        "name": "Marianao",
        "fk_idCity": "1108200",
        "lat": 41.3528662,
        "lng": 2.0210127
    },
    {
        "id": "3120108",
        "name": "Mendillori",
        "fk_idCity": "1131201",
        "lat": 42.8096351,
        "lng": -1.6113419
    },
    {
        "id": "2906707",
        "name": "M\u00e1laga Norte",
        "fk_idCity": "1129067",
        "lat": 36.7461853,
        "lng": -4.4228792
    },
    {
        "id": "3603803",
        "name": "Louriz\u00e1n & Salcedo",
        "fk_idCity": "1136038",
        "lat": 42.3922276,
        "lng": -8.6593258
    },
    {
        "id": "2907001",
        "name": "Mijas",
        "fk_idCity": "1129070",
        "lat": 36.5967755,
        "lng": -4.6323067
    },
    {
        "id": "3603804",
        "name": "Mourente & Marc\u00f3n",
        "fk_idCity": "1136038",
        "lat": 42.4377212,
        "lng": -8.6181824
    },
    {
        "id": "2807914",
        "name": "Moratalaz",
        "fk_idCity": "1128079",
        "lat": 40.4072203,
        "lng": -3.6570055
    },
    {
        "id": "5029708",
        "name": "Miralbueno / Oliver-Valdefierro",
        "fk_idCity": "1150297",
        "lat": 41.6593007,
        "lng": -0.946076
    },
    {
        "id": "820505",
        "name": "Mirasol",
        "fk_idCity": "1108205",
        "lat": 41.4693995,
        "lng": 2.0418898
    },
    {
        "id": "2807909",
        "name": "Moncloa-Aravaca",
        "fk_idCity": "1128079",
        "lat": 40.43949485,
        "lng": -3.74420353965471
    },
    {
        "id": "1402103",
        "name": "Noroeste",
        "fk_idCity": "1114021",
        "lat": 37.8888925,
        "lng": -4.7976431
    },
    {
        "id": "704003",
        "name": "Norte",
        "fk_idCity": "1107040",
        "lat": 39.6324979,
        "lng": 2.6288523
    },
    {
        "id": "820502",
        "name": "N\u00facleo Sur",
        "fk_idCity": "1108205",
        "lat": 41.4720702,
        "lng": 2.0865154
    },
    {
        "id": "4109107",
        "name": "Norte",
        "fk_idCity": "1141091",
        "lat": 37.417393,
        "lng": -5.965587999999999
    },
    {
        "id": "4516504",
        "name": "Patrocinio de San Jos\u00e9",
        "fk_idCity": "1145165",
        "lat": 39.9513275,
        "lng": -4.8525015
    },
    {
        "id": "2807402",
        "name": "Norte",
        "fk_idCity": "1128074",
        "lat": 40.3436286,
        "lng": -3.7483176
    },
    {
        "id": "4625008",
        "name": "Patraix",
        "fk_idCity": "1146250",
        "lat": 39.462494,
        "lng": -0.3913172
    },
    {
        "id": "4516502",
        "name": "Nuevo Centro",
        "fk_idCity": "1145165",
        "lat": 39.962884,
        "lng": -4.830453599999999
    },
    {
        "id": "2814802",
        "name": "Parque Catalu\u00f1a, Mancha Amarilla y Soto del Henares",
        "fk_idCity": "1128148",
        "lat": 40.4638008,
        "lng": -3.4413969
    },
    {
        "id": "801908",
        "name": "Nou Barris",
        "fk_idCity": "1108019",
        "lat": 41.4459814,
        "lng": 2.1794589
    },
    {
        "id": "3003007",
        "name": "Norte",
        "fk_idCity": "1130030",
        "lat": 37.9922399,
        "lng": -1.1306544
    },
    {
        "id": "1402110",
        "name": "Periurbano Oeste-Sierra",
        "fk_idCity": "1114021",
        "lat": 37.8881751,
        "lng": -4.7793835
    },
    {
        "id": "4625018",
        "name": "Poblados del Oeste",
        "fk_idCity": "1146250",
        "lat": 39.4986397,
        "lng": -0.4148744
    },
    {
        "id": "3002402",
        "name": "Pedan\u00edas",
        "fk_idCity": "1130024",
        "lat": 37.6735925,
        "lng": -1.6968357
    },
    {
        "id": "4625019",
        "name": "Poblados del Sur",
        "fk_idCity": "1146250",
        "lat": 39.3304293,
        "lng": -0.3654204
    },
    {
        "id": "2906903",
        "name": "Nueva Andaluc\u00eda-Guadalp\u00edn",
        "fk_idCity": "1129069",
        "lat": 36.483152,
        "lng": -4.96637
    },
    {
        "id": "4802003",
        "name": "Otxarkoaga & Txurdinaga",
        "fk_idCity": "1148020",
        "lat": 43.261337,
        "lng": -2.8984036
    },
    {
        "id": "3302406",
        "name": "Pumar\u00edn",
        "fk_idCity": "1133024",
        "lat": 43.52461,
        "lng": -5.6734057
    },
    {
        "id": "1402106",
        "name": "Poniente-Sur",
        "fk_idCity": "1114021",
        "lat": 37.8785201,
        "lng": -4.792463
    },
    {
        "id": "704002",
        "name": "Poniente",
        "fk_idCity": "1107040",
        "lat": 39.5916564,
        "lng": 2.6090043
    },
    {
        "id": "704005",
        "name": "Playa de Palma",
        "fk_idCity": "1107040",
        "lat": 39.5372211,
        "lng": 2.7170189
    },
    {
        "id": "820501",
        "name": "N\u00facleo Norte",
        "fk_idCity": "1108205",
        "lat": 41.4720702,
        "lng": 2.0865154
    },
    {
        "id": "1402105",
        "name": "Poniente-Norte",
        "fk_idCity": "1114021",
        "lat": 37.8842379,
        "lng": -4.814481799999999
    },
    {
        "id": "4625011",
        "name": "Poblados Mar\u00edtimos",
        "fk_idCity": "1146250",
        "lat": 39.45232850000001,
        "lng": -0.3301342
    },
    {
        "id": "4625010",
        "name": "Quatre Carreres",
        "fk_idCity": "1146250",
        "lat": 39.44964909999999,
        "lng": -0.3607137
    },
    {
        "id": "4625017",
        "name": "Poblados del Norte",
        "fk_idCity": "1146250",
        "lat": 39.5168502,
        "lng": -0.3842527
    },
    {
        "id": "2807407",
        "name": "Polvoranca",
        "fk_idCity": "1128074",
        "lat": 40.3254281,
        "lng": -3.7884808
    },
    {
        "id": "2408908",
        "name": "Puente Castro",
        "fk_idCity": "1124089",
        "lat": 42.5810002,
        "lng": -5.5525889
    },
    {
        "id": "824504",
        "name": "R\u00edo Norte & R\u00edo Sur",
        "fk_idCity": "1108245",
        "lat": 40.5313204,
        "lng": -3.6455417
    },
    {
        "id": "2807913",
        "name": "Puente de Vallecas",
        "fk_idCity": "1128079",
        "lat": 40.3870042,
        "lng": -3.6695334
    },
    {
        "id": "4624403",
        "name": "Raval",
        "fk_idCity": "1146244",
        "lat": 39.4376368,
        "lng": -0.4637391
    },
    {
        "id": "4516501",
        "name": "Puente de Castilla & La Mancha",
        "fk_idCity": "1145165",
        "lat": 42.3370487,
        "lng": -3.708627
    },
    {
        "id": "4625015",
        "name": "Rasca\u00f1a",
        "fk_idCity": "1146250",
        "lat": 39.4936236,
        "lng": -0.367774
    },
    {
        "id": "2807903",
        "name": "Retiro",
        "fk_idCity": "1128079",
        "lat": 40.4152606,
        "lng": -3.6844995
    },
    {
        "id": "3302409",
        "name": "Rural",
        "fk_idCity": "1133024",
        "lat": 43.5322015,
        "lng": -5.6611195
    },
    {
        "id": "1402104",
        "name": "Norte-Sierra",
        "fk_idCity": "1114021",
        "lat": 37.9079349,
        "lng": -4.784693799999999
    },
    {
        "id": "2812301",
        "name": "Rivas-Vaciamadrid",
        "fk_idCity": "1128123",
        "lat": 40.3469651,
        "lng": -3.5306765
    },
    {
        "id": "3803804",
        "name": "Ofra-Costa Sur",
        "fk_idCity": "1138038",
        "lat": 28.4484322,
        "lng": -16.2846568
    },
    {
        "id": "4801303",
        "name": "Rontegi",
        "fk_idCity": "1148013",
        "lat": 43.2940802,
        "lng": -2.9851665
    },
    {
        "id": "3120107",
        "name": "Rochapea, San Jorge, Buztintxuri",
        "fk_idCity": "1131201",
        "lat": 42.8275959,
        "lng": -1.6499813
    },
    {
        "id": "3412004",
        "name": "San Antonio",
        "fk_idCity": "1134120",
        "lat": 42.0202361,
        "lng": -4.543903
    },
    {
        "id": "2807920",
        "name": "San Blas - Canillejas",
        "fk_idCity": "1128079",
        "lat": 40.4275001,
        "lng": -3.615954
    },
    {
        "id": "4109108",
        "name": "San Pablo & Santa Justa",
        "fk_idCity": "1141091",
        "lat": 37.9621457,
        "lng": -122.3455263
    },
    {
        "id": "824502",
        "name": "Latino, Riera Alta & Cementerio Viejo",
        "fk_idCity": "1108245",
        "lat": 41.4561854,
        "lng": 2.2152245
    },
    {
        "id": "905909",
        "name": "R\u00edo Pico, La Inmaculada & Pol\u00edgono Del Gamonal",
        "fk_idCity": "1109059",
        "lat": -44.1806707,
        "lng": -71.3691758
    },
    {
        "id": "5029705",
        "name": "San Jos\u00e9",
        "fk_idCity": "1150297",
        "lat": 41.63036719999999,
        "lng": -0.8651302999999999
    },
    {
        "id": "801905",
        "name": "Sarri\u00e1 & San Gervasio",
        "fk_idCity": "1108019",
        "lat": 41.4039419,
        "lng": 2.130598
    },
    {
        "id": "2408905",
        "name": "Santa Ana & Pol\u00edgono X",
        "fk_idCity": "1124089",
        "lat": 33.7454725,
        "lng": -117.867653
    },
    {
        "id": "501905",
        "name": "Santo Tom\u00e1s-Universidad",
        "fk_idCity": "1105019",
        "lat": 40.66687,
        "lng": -4.704884
    },
    {
        "id": "2807403",
        "name": "San Nicasio",
        "fk_idCity": "1128074",
        "lat": 40.3344744,
        "lng": -3.7695736
    },
    {
        "id": "2807904",
        "name": "Salamanca",
        "fk_idCity": "1128079",
        "lat": 40.4279488,
        "lng": -3.68675
    },
    {
        "id": "501903",
        "name": "San Nicol\u00e1s-Las Vacas",
        "fk_idCity": "1105019",
        "lat": 40.6525058,
        "lng": -4.6937039
    },
    {
        "id": "801903",
        "name": "Sants & Montjuic",
        "fk_idCity": "1108019",
        "lat": 41.3754426,
        "lng": 2.1355003
    },
    {
        "id": "801910",
        "name": "San Mart\u00edn",
        "fk_idCity": "1108019",
        "lat": 41.4100098,
        "lng": 2.2029804
    },
    {
        "id": "905903",
        "name": "San Pedro De La Fuente, Barriada Yague & Villalonquejar",
        "fk_idCity": "1109059",
        "lat": 42.3436776,
        "lng": -3.7134945
    },
    {
        "id": "3603806",
        "name": "Santo Andr\u00e9 de Xeve",
        "fk_idCity": "1136038",
        "lat": 42.4631018,
        "lng": -8.587250899999999
    },
    {
        "id": "1402107",
        "name": "Sur",
        "fk_idCity": "1114021",
        "lat": 37.8700939,
        "lng": -4.7790355
    },
    {
        "id": "3907503",
        "name": "San Mart\u00edn-San Roque",
        "fk_idCity": "1139075",
        "lat": 43.4636346,
        "lng": -3.8226402
    },
    {
        "id": "4804401",
        "name": "Santa Mar\u00eda de Getxo",
        "fk_idCity": "1148044",
        "lat": 43.3643742,
        "lng": -3.0179146
    },
    {
        "id": "2807401",
        "name": "Sur",
        "fk_idCity": "1128074",
        "lat": 40.3319506,
        "lng": -3.7686545
    },
    {
        "id": "3802301",
        "name": "San Crist\u00f3bal de la Laguna",
        "fk_idCity": "1138023",
        "lat": 28.4874009,
        "lng": -16.3159061
    },
    {
        "id": "1402108",
        "name": "Sureste",
        "fk_idCity": "1114021",
        "lat": 37.88379949999999,
        "lng": -4.7600984
    },
    {
        "id": "818402",
        "name": "Sant Mu\u00e7, Castellnou & Can Mir",
        "fk_idCity": "1108184",
        "lat": 41.5089205,
        "lng": 2.0223279
    },
    {
        "id": "4801305",
        "name": "San Vicente",
        "fk_idCity": "1148013",
        "lat": 43.2954737,
        "lng": -2.9937984
    },
    {
        "id": "3802303",
        "name": "Taco-Geneto-Las Chumberas-Guajara-Los Andenes",
        "fk_idCity": "1138023",
        "lat": 28.466052,
        "lng": -16.3105624
    },
    {
        "id": "3803805",
        "name": "Suroeste",
        "fk_idCity": "1138038",
        "lat": 28.4341022,
        "lng": -16.3200704
    },
    {
        "id": "2807906",
        "name": "Tetu\u00e1n",
        "fk_idCity": "1128079",
        "lat": 40.45883510000001,
        "lng": -3.6978264
    },
    {
        "id": "3003008",
        "name": "Sta. M\u00aa de Gracia-San Antonio",
        "fk_idCity": "1130030",
        "lat": 37.984616,
        "lng": -1.1264436
    },
    {
        "id": "105904",
        "name": "Sureste",
        "fk_idCity": "1101059",
        "lat": 42.8531869,
        "lng": -2.6732421
    },
    {
        "id": "105902",
        "name": "Suroeste",
        "fk_idCity": "1101059",
        "lat": 42.8531869,
        "lng": -2.6732421
    },
    {
        "id": "4109105",
        "name": "Sur",
        "fk_idCity": "1141091",
        "lat": 37.3890924,
        "lng": -5.9844589
    },
    {
        "id": "2909403",
        "name": "Torre del Mar, Mezquitilla, Caleta de V\u00e9lez & Lagos",
        "fk_idCity": "1129094",
        "lat": 36.7456758,
        "lng": -4.0366574
    },
    {
        "id": "5029709",
        "name": "Torrero",
        "fk_idCity": "1150297",
        "lat": 41.6240333,
        "lng": -0.8782392
    },
    {
        "id": "3501601",
        "name": "Vegueta, Cono Sur & Tafira",
        "fk_idCity": "1135016",
        "lat": 28.1004682,
        "lng": -15.4155001
    },
    {
        "id": "5029704",
        "name": "Universidad",
        "fk_idCity": "1150297",
        "lat": 41.6420639,
        "lng": -0.9015065
    },
    {
        "id": "2909401",
        "name": "V\u00e9lez-M\u00e1laga",
        "fk_idCity": "1129094",
        "lat": 36.7799228,
        "lng": -4.1005589
    },
    {
        "id": "2807912",
        "name": "Usera",
        "fk_idCity": "1128079",
        "lat": 40.3825927,
        "lng": -3.7098748
    },
    {
        "id": "2906704",
        "name": "Victoria",
        "fk_idCity": "1129067",
        "lat": 36.726336,
        "lng": -4.4130161
    },
    {
        "id": "2807917",
        "name": "Villaverde",
        "fk_idCity": "1128079",
        "lat": 40.3469109,
        "lng": -3.7107845
    },
    {
        "id": "3120106",
        "name": "Txantrea, Orvina",
        "fk_idCity": "1131201",
        "lat": 42.8334132,
        "lng": -1.6278429
    },
    {
        "id": "2811501",
        "name": "Urbanizaciones",
        "fk_idCity": "1128115",
        "lat": 40.4440627,
        "lng": -3.8058517
    },
    {
        "id": "2807918",
        "name": "Villa de Vallecas",
        "fk_idCity": "1128079",
        "lat": 40.3669555,
        "lng": -3.606064
    },
    {
        "id": "2807919",
        "name": "Vic\u00e1lvaro",
        "fk_idCity": "1128079",
        "lat": 40.3940279,
        "lng": -3.6028761
    },
    {
        "id": "3302405",
        "name": "Trema\u00f1es",
        "fk_idCity": "1133024",
        "lat": 43.5285726,
        "lng": -5.7141879
    },
    {
        "id": "4801308",
        "name": "Lutxana Burtze\u00f1a",
        "fk_idCity": "1148013",
        "lat": 43.2969875,
        "lng": -2.9862029
    },
    {
        "id": "2814804",
        "name": "Zona Centro",
        "fk_idCity": "1128148",
        "lat": 40.4567552,
        "lng": -3.4754967
    },
    {
        "id": "812103",
        "name": "Vista Alegre",
        "fk_idCity": "1108121",
        "lat": 41.551828,
        "lng": 2.445655
    },
    {
        "id": "2816102",
        "name": "Zona industrial",
        "fk_idCity": "1128161",
        "lat": 40.1912635,
        "lng": -3.6740351
    },
    {
        "id": "2805805",
        "name": "Vivero Hospital Universidad",
        "fk_idCity": "1128058",
        "lat": 40.2889365,
        "lng": -3.8186219
    },
    {
        "id": "2807404",
        "name": "Zarzaquemada",
        "fk_idCity": "1128074",
        "lat": 40.33463039999999,
        "lng": -3.7524579
    },
    {
        "id": "2814804",
        "name": "Zona Centro",
        "fk_idCity": "1128148",
        "lat": 40.4567552,
        "lng": -3.4754967
    },
    {
        "id": "2816102",
        "name": "Zona industrial",
        "fk_idCity": "1128161",
        "lat": 40.1912635,
        "lng": -3.6740351
    }
]